export default __webpack_public_path__ + "static/Mallory-Bold-d1ba65dd56f631f94b300a51acd362d2.woff";